const name = 'USER'

export const GET = `${name}_GET`;
export const GET_SUCCESS = `${name}_GET_SUCCESS`;
export const GET_ERROR = `${name}_GET_ERROR`;
export const ADD = `${name}_ADD`;
export const ADD_SUCCESS = `${name}_ADD_SUCCESS`;
export const UPDATE = `${name}_UPDATE`;
export const UPDATE_SUCCESS = `${name}_UPDATE_SUCCESS`;
export const DELETE = `${name}_DELETE`;
export const DELETE_SUCCESS = `${name}_DELETE_SUCCESS`;

export const MANIPULATION_ERROR = `${name}_MANIPULATION_ERROR`;

export const GET_PERMISSION = `${name}_GET_PERMISSION`;
export const GET_PERMISSION_SUCCESS = `${name}_GET_PERMISSION_SUCCESS`;

export const RESTORE_PERMISSIONS = `${name}_RESTORE_PERMISSIONS`;
export const RESTORE_PERMISSIONS_SUCCESS = `${name}_RESTORE_PERMISSIONS_SUCCESS`;

export const PASSWORDLESS_TOKEN = `${name}_PASSWORDLESS_TOKEN`;
export const PASSWORDLESS_TOKEN_SUCCESS = `${name}_PASSWORDLESS_TOKEN_SUCCESS`;
